export type HomeSearchItemType = 'DOCUMENT' | 'REGISTRATION';
export type HomeSearchCriteria = 'prefix' | 'name';

export interface HomeSearchTab {
  id: HomeSearchItemType;
  label: string;
}

export interface HomeSearchCriteriaOption {
  id: HomeSearchCriteria;
  name: string;
}

export const HOME_SEARCH_TABS: HomeSearchTab[] = [
  { id: 'DOCUMENT', label: 'Documentos' },
  { id: 'REGISTRATION', label: 'Registros' },
];

export const HOME_SEARCH_CRITERIA_OPTIONS: HomeSearchCriteriaOption[] = [
  { id: 'prefix', name: 'Prefixo' },
  { id: 'name', name: 'Título' },
];

export const HOME_SEARCH_DEFAULTS = {
  itemType: 'DOCUMENT',
  criteria: 'prefix',
  debounceMs: 300,
} as const satisfies {
  itemType: HomeSearchItemType;
  criteria: HomeSearchCriteria;
  debounceMs: number;
};
